import './lib/globalShim';
// Required polyfill for fullcalendar on iOS
import 'intl';
import 'intl/locale-data/jsonp/nb-NO';

import './lib/registerJQuery';

import noVueCalendar from './lang/calendarLang/no'
import svVueCalendar from './lang/calendarLang/sv'
import kkVueCalendar from './lang/calendarLang/kk'
import enVueCalendar from './lang/calendarLang/en'

window.VueCalendarLang = function (lang) {
    switch (lang) {
        case 'kk':
            return kkVueCalendar
        case 'en':
            return enVueCalendar
        case 'sv':
            return svVueCalendar
        case 'no':
        default:
            return noVueCalendar
    }
};

import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import s3helper from './lib/s3helper'
import { LGDLogger } from "./lib/LGDLogger";

window.i18n = createI18n({
    locale: window.preferredLanguage,
    fallbackLocale: window.locale,
    messages: window.jsMessages,
    legacy: false // Vue 3 Composition API mode
});

import L10n from '@limegreendigital/l10n-js'
L10n.boot({
    language: window.jsLocale,
    region: window.jsLocale,
})
window.L10n = L10n

window.$t = function (key, values, choice) {
    return window.i18n.global.t(key, values, choice);
}


window.hasModule = function (module) {
    const modules = window.permissions.modules;
    var retval = modules[module];
    if (typeof (retval) === "undefined") {
        return false;
    }
    return retval;
}
window.hasFeature = function (feature) {
    const features = window.permissions.features;
    var retval = features[feature];
    if (typeof (retval) === "undefined") {
        return true;
    }
    return retval;
}
window.isFeature = function (feature) {
    const features = window.permissions.features;
    var retval = features[feature];
    if (typeof (retval) === "undefined") {
        return false;
    }
    return true;
}

window.enforceCDN = s3helper.enforceCDN;

import Account from './components/account/Account.vue';
import TcElementQuestions from './components/tcElementQuestions/TcElementQuestions.vue';
import Calendar from './components/calendar/Calendar.vue';
import ClassSelect from './components/classSelect/ClassSelect.vue';
import PaymentMethods from './components/payment/PaymentMethods.vue';
import PayableInvoiceList from './components/payment/PayableInvoiceList.vue';
import NotificationList from './components/notifications/List.vue';
import VippsNoSession from './components/nosession/Vipps.vue';
import PaymentNoSession from './components/nosession/Payment.vue';
import PaymentResponse from './components/nosession/PaymentResponse.vue';
import TeachingCard from './components/teachingCard/TeachingCard.vue';
import VippsPaymentProgress from './components/payment/VippsPaymentProgress.vue';
import TheoryExamDatePrompt from './components/theory/ExamDatePrompt.vue';
import ConversationPage from './components/messaging/ConversationPage.vue';
import PracticeDriveRoute from './components/practicedrive/Route.vue';
import Header from './components/header/Header.vue';
import LessonHistory from './components/activities/History.vue';
import ProfileForm from './components/user/Profile.vue';
import ProfileContactList from './components/user/Contact.vue';
import FileUploader from './components/fileuploader/FileUploader.vue';
import DocumentList from './components/documents/DocumentList.vue';
import ChangePassword from './components/user/ChangePassword.vue';
import Survey from './components/survey/Survey.vue';
import CompanyContactAccount from './components/account/CompanyContactAccount.vue';
import VippsCreationWizard from './components/VippsUserCreationWizard/VippsCreationWizard.vue';
import AlertCard from './components/dashboard/AlertCard.vue';
import NoEmailRegisteredCard from './components/dashboard/NoEmailRegisteredCard.vue';
import '@vuepic/vue-datepicker/dist/main.css'

import './activities';

import { Dropdown, Tooltip } from "bootstrap";
const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');

for (let el of tooltipElements) {
    new Tooltip(el, {});
}

if (document.getElementById('app')) {
    const app = createApp({
        i18n,
        components: {
            Account,
            Calendar,
            'tcelementquestions': TcElementQuestions,
            'Classdropdown': ClassSelect,
            'payment-methods': PaymentMethods,
            'notificationlist': NotificationList,
            'vippsnosession': VippsNoSession,
            'paymentnosession': PaymentNoSession,
            'payment-in-progress': PaymentResponse,
            'payable-invoice-list': PayableInvoiceList,
            'teachingcard': TeachingCard,
            'vipps-payment-in-progress': VippsPaymentProgress,
            'theory-exam-date-prompt': TheoryExamDatePrompt,
            'conversation-page': ConversationPage,
            'practice-drive-route': PracticeDriveRoute,
            'mobile-header': Header,
            'lesson-history': LessonHistory,
            'profile-form': ProfileForm,
            'profile-contactlist': ProfileContactList,
            'file-uploader': FileUploader,
            'document-list': DocumentList,
            'change-password': ChangePassword,
            Survey,
            'company-contact-account': CompanyContactAccount,
            'vipps-creation-wizard': VippsCreationWizard,
            'alert-card': AlertCard,
            'no-email-registered-card': NoEmailRegisteredCard,
        }
    });

    app.use(i18n);

    app.config.globalProperties.$window = window;

    app.config.warnHandler = (msg, instance, info) => {
        LGDLogger.warn({ msg, info });
    };

    app.config.errorHandler = (error, instance, info) => {
        LGDLogger.error({ error, info });
    };

    app.mount('#app');
}

const navExpandMore = document.getElementById('nav-expand-more');
const navExpandMoreOverlay = document.getElementById('nav-expand-more-overlay');
const body = document.getElementsByTagName('body')[0];

const toggleNavMoreMenuEl = document.getElementById('toggle-nav-more-menu')
if (toggleNavMoreMenuEl) {
    toggleNavMoreMenuEl.addEventListener('click', function (e) {
        e.preventDefault();
        if (navExpandMore.classList.contains('show')) {
            navExpandMoreOverlay.click()
        } else {
            navExpandMore.classList.add('show');
            toggleOverlay(navExpandMoreOverlay, true);
            body.classList.add('modal-open');
        }
    });
}

if (navExpandMoreOverlay) {
    navExpandMoreOverlay.addEventListener('click', function (e) {
        e.preventDefault();
        navExpandMore.classList.remove('show');
        toggleOverlay(navExpandMoreOverlay, false);
        body.classList.remove('modal-open');
    });
}

window.toggleOverlay = function (overlay, show) {
    if (show) {
        overlay.classList.add('show');
    } else {
        overlay.classList.remove('show');
    }
}

window.initBioSettings = function (canCheck, hasCredentials, hasBeenPrompted, isEnabled) {
    if (canCheck && hasCredentials) {
        document.getElementById('app-settings').classList.remove('d-none');
    }
    if (isEnabled) {
        document.getElementById('biometric-auth').checked = true;
    }
    document.getElementById('biometric-auth').addEventListener('change', function () { console.log(JSON.stringify({ 'bioAuthSettingChange': document.getElementById('biometric-auth').checked })) });
}

import Api from './api/BaseRequest';
window.updateBiometricStatus = function (isEnabled) {
    Api.Post('/api/user/bio', { enabled: isEnabled });
}

window.setLanguage = (lang) => {
    return Api.Put('/api/account/language', { lang })
}
